var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasImage)?_c('b-avatar',{staticClass:"avatar-border",attrs:{"src":_vm.image,"size":_vm.size}}):_c('b-avatar',{staticClass:"avatar-border",style:({ backgroundColor: _vm.randomColor, color: 'white' }),attrs:{"text":_vm.getInitials(_vm.text),"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }